import type { Appointment } from '../store/types';

/* ============================================================
   Google Calendar "render" links — scheduling with clients
   THROUGH Google without touching the Calendar API (whose
   write scope is "sensitive" and would put the OAuth app
   through Google's verification review).

   The link opens Google Calendar with the event prefilled and
   the client pre-added as a guest; when the coach hits Save,
   GOOGLE sends the email invite, the reminders, and tracks the
   RSVP. Times are passed as UTC instants (trailing Z) so they
   land correctly in any calendar timezone.
============================================================ */

const gdate = (iso: string): string =>
  new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

export function googleCalendarUrl(appt: Appointment): string {
  const p = new URLSearchParams();
  p.set('action', 'TEMPLATE');
  p.set('text', appt.title || (appt.attendeeName ? `Session — ${appt.attendeeName}` : 'Appointment'));
  p.set('dates', `${gdate(appt.startsAt)}/${gdate(appt.endsAt)}`);
  if (appt.location) p.set('location', appt.location);
  const details = [appt.notes, 'Scheduled with FitFlex — https://fitflex.club'].filter(Boolean).join('\n\n');
  p.set('details', details);
  if (appt.attendeeEmail) p.set('add', appt.attendeeEmail); // Google invites this guest on save
  if (appt.rrule) p.set('recur', `RRULE:${appt.rrule}`);
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}
